import { StarPlusOutlineIcon } from './StarPlusOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 0CBFD9AD-12B1-4AAF-A9CC-9CA46FEB47FD
 * name star-plus-outline
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-plus-outline.svg
 * tags
 * - Shape 
 */
export const StarAddOutlineIcon = StarPlusOutlineIcon;
export default StarAddOutlineIcon